import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CreateBracketPage from "./pages/create/CreateBracketPage";
import ViewBracketPage from "./pages/view/ViewBracketPage";
import VerifyEmailContainer from "./pages/verifyEmail/VerifyEmailContainer";
import LandingPage from "./pages/landing/LandingPage";
import ResetPasswordContainer from "./pages/resetPassword/ResetPasswordContainer";
import ForgotPasswordContainer from "pages/forgotPassword/ForgotPasswordContainer";
import AccountPage from "pages/account/AccountPage";
import ContactUs from "pages/contactUs/ContactUs";
import ErrorPage from "pages/error/ErrorPage";

import './App.css';
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "utilities/js/callouts/CalloutFactory";
import { isLoggedIn } from "utilities/js/ActionLibrary";

const cookieManager = new CookieManager();

const App = props => {

        const notificationResponse = useQuery({
            queryKey: ['unreadNotifications'],
            queryFn: () => getNotifications({readStatus: false}),
            staleTime: Infinity,
            enabled: isLoggedIn()
        });

        return (
            <>
                    <Router>
                        <div className="main-container">
                            <Routes>

                                <Route exact path='/' element={<LandingPage />}></Route>
                                <Route exact path='/account/:accountId' element={< AccountPage />}></Route>
                                <Route exact path='/bracket/:bracketId/view' element={< ViewBracketPage />}></Route>
                                <Route exact path='/bracket/:bracketId/create' element={< CreateBracketPage />}></Route>
                                <Route exact path='/bracket/create' element={< CreateBracketPage />}></Route>
                                <Route exact path='/verify-email' element={< VerifyEmailContainer />}></Route>
                                <Route exact path='/reset-password' element={< ResetPasswordContainer />}></Route>
                                <Route exact path='/forgot-password' element={< ForgotPasswordContainer />}></Route>
                                <Route exact path='/contact' element={< ContactUs />}></Route>
                                <Route exact path='/error' element={< ErrorPage />}></Route>
                                
                            </Routes>
                        </div>
                    </Router>
            </>
        );
}

export default App;
